import { userVoiceFeedbackDiscardButton } from 'owa-locstrings/lib/strings/uservoicefeedbackdiscardbutton.locstring.json';
import loc from 'owa-localize';

import { observer } from 'mobx-react';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import * as React from 'react';

let styles = require('./UserVoiceDisclaimerDialog.scss');

export interface UserVoiceDisclaimerProps {
    onClose: () => void;
    title?: string;
    disclaimerLine1?: string;
    disclaimerLine2?: string;
}

interface DisclaimerDialogState {
    isShown: boolean;
}

let counter: number = 0;

@observer
export default class UserVoiceDisclaimerDialog extends React.Component<
    UserVoiceDisclaimerProps,
    DisclaimerDialogState
> {
    private discardId = `discard-${counter++}`;

    constructor(props: any) {
        super(props);
        this.state = {
            isShown: true,
        };
    }

    render() {
        const { title, disclaimerLine1, disclaimerLine2 } = this.props;

        return (
            <Dialog
                isOpen={this.state.isShown}
                type={DialogType.normal}
                onDismiss={this.onClose}
                title={title}>
                <div>
                    <Label className={styles.userVoiceDisclaimerLabel}>{disclaimerLine1}</Label>
                    <Label>{disclaimerLine2}</Label>
                </div>

                <DialogFooter>
                    <PrimaryButton id={this.discardId} onClick={this.onClose}>
                        {loc(userVoiceFeedbackDiscardButton)}
                    </PrimaryButton>
                </DialogFooter>
            </Dialog>
        );
    }

    private onClose = () => {
        this.props.onClose();

        this.setState({
            isShown: false,
        });
    };
}
